export default __webpack_public_path__ + "static/media/bg-masthead-1-800w.98633280.jpg";